import React from "react";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";

const NoOfferingsFound = ({ searchQuery, loading, options }) => {
  if (loading || !checkIsArrayEmpty(options) || !searchQuery) {
    return null;
  }

  return (
    <div
      style={{
        padding: "16px 8px 8px",
        textAlign: "center",
        color: "#666",
        fontSize: "14px",
      }}
    >
      No offerings found matching &quot;{searchQuery}&quot;
    </div>
  );
};

export default NoOfferingsFound;
